import { render, staticRenderFns } from "./minimum-age-select.vue?vue&type=template&id=719fa26e&scoped=true&"
import script from "./minimum-age-select.vue?vue&type=script&lang=js&"
export * from "./minimum-age-select.vue?vue&type=script&lang=js&"
import style0 from "./minimum-age-select.vue?vue&type=style&index=0&id=719fa26e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719fa26e",
  null
  
)

export default component.exports